import defaultTheme from './defaultTheme';
import constants from '../../constants';
export default {
  ...defaultTheme,
  background: constants.Colors.RegalBlue,
  profileIndicatorBG: '#040628',
  stepIndicatorLabelFinishedColor: '#00ab5e',
  stepIndicatorLabelUnFinishedColor: '#1c254f',
  stepIndicatorLabelActiveColor: '#fff',
  profileIndicatorBtn: 'transparent',
  profileIndicatorBtnBorder: '#f6324b',
  profileIndicatorBtnLabel: '#fff'
};
